import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

/**
 * BreadCrumb Component
 * Displays a breadcrumb navigation with an optional title and children.
 */
const BreadCrumb = ({ className = '', title, children }) => {
    const { t } = useTranslation();

    return (
        <div className={`inner_table ${className}`}>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="bridcrumb">
                            <Link to="/">{t('breadcrumb.home')}</Link> / {title}
                        </div>
                    </div>
                </div>
                {children}
            </div>
        </div>
    );
};

export default BreadCrumb;
